import css from './tabListA.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import SwiperA from './swiperA';
import KitD from './kitD';
import KitE from './kitE';
import KitF from './kitF';
import KitG from './kitG';
import KitH from './kitH';
import KitI from './kitI';
import KitL from './kitL';
import KitM from './kitM';
import ListA from './listA';
import ListB from './listB';
import ListC from './listC';
import ListD1 from './listD/listD1';
import ListD2 from './listD/listD2';

export default function TabListA({ callBack }: any) {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecoflowpowerkitsseries');

    const swiperAData = {
        title1: t('presale.product.tab_listA_title1'),
        title2: t('presale.product.tab_listA_title2'),
        list: [
            {
                i18n: 'classA',
                src: ['/video/mm100m/classA_h5.webm', '/video/mm100/classA_h5.mp4'],
                class: 'rv-video-1',
            },
            {
                i18n: 'classB',
                src: ['/video/mm100m/classB_h5.webm', '/video/mm100/classB_h5.mp4'],
                class: 'rv-video-2',
            },
            {
                i18n: 'classC',
                src: ['/video/mm100m/classC_h5.webm', '/video/mm100/classC_h5.mp4'],
                class: 'rv-video-3',
            },
            {
                i18n: 'trailer',
                src: ['/video/mm100m/trailer_h5.webm', '/video/mm100/trailer_h5.mp4'],
                class: 'rv-video-4',
            },
        ],
    };

    return (
        <div className={`${css.tabListA} tabListA`}>
            <SwiperA data={swiperAData} customClass="left-swiper" pagingClass="left-paging" tab="rv" />
            <KitD />
            <KitE type="rv" customClass="kitE-rv" callBack={callBack} />
            <KitF type="rv" />
            <KitG type="rv" customClass="kitG-rv" />
            <KitH type="rv" customClass="kitH-rv" videoClass1="rv-video1" videoClass2="rv-video2" />
            <ListA />
            <KitI type="rv" />
            <ListB callBack={callBack} customClass="listB-rv" type="rv" />
            <KitL callBack={callBack} active="kitL" />
            <KitM callBack={callBack} active="kitM" />
            <ListC callBack={callBack} type="rv" active="listC" />
            <ListD1 callBack={callBack} active="listD1" />
            <ListD2 callBack={callBack} active="listD2" />
        </div>
    );
}
